import BaseSetup from '@/components/BaseSetup';
import { itemIs } from '@orion.ui/orion';

export type SharedDetailsDocumentHistoryEmits = {};
export type SharedDetailsDocumentHistoryProps = {
	useTimeStamp?: boolean
	document: Armado.ArmadoDocument
};

export default class SharedDetailsDocumentHistorySetup extends BaseSetup {

	static readonly defaultProps = {};

	constructor (
		private props: SharedDetailsDocumentHistoryProps,
		private emits: SharedDetailsDocumentHistoryEmits,
	) {
		super();
	}

	documentWithSignature (document: Armado.ArmadoDocument): document is Armado.ArmadoDocument & { document: IDocumentWithSignatureModel } {
		if (!document.document) return false;
		if (itemIs<IDocumentWithSignatureModel>(document.document, 'agencySignatureDate')) {
			return true;
		}
		return false;
	}

}
